<div class="municipality-container">

    <form id="person-form" [formGroup]="personForm">

        <div class="form-search-type">
            <label><input type="radio" value="documento" formControlName="searchType">Búsqueda por documento</label>
            <label><input type="radio" value="defuncion" formControlName="searchType">Búsqueda por datos de
                defunción</label>
        </div>


        <div *ngIf="personForm.get('searchType')?.value === 'documento'">
            <div class="form-container">
                <div class="form-field">
                    <label class="labelTitle" for="identifier">{{ 'PREVIEW_SPACE.IDENTIFIER' | translate }}</label>
                    <input id="identifier" type="text" formControlName="identifier">
                </div>
                <div class="form-field">
                    <label class="labelTitle" for="nombre">{{ 'PREVIEW_SPACE.NAME' | translate }}</label>
                    <input id="nombre" type="text" formControlName="nombre">
                </div>
                <div class="form-field">
                    <label class="labelTitle" for="apellido1">{{ 'PREVIEW_SPACE.SURNAME1' | translate }}</label>
                    <input id="apellido1" type="text" formControlName="apellido1">
                </div>
                <!-- <div class="form-field">
                <label class="labelTitle" for="apellido2">{{ 'PREVIEW_SPACE.SURNAME2' | translate }}</label>
                <input id="apellido2" type="text" formControlName="apellido2">
            </div> -->
            </div>
        </div>

        <div *ngIf="personForm.get('searchType')?.value === 'defuncion'">
            <div class="form-container">
                <div class="form-field-extended">
                    <label class="labelTitle" for="nombre">{{ 'PREVIEW_SPACE.NAME' | translate }}</label>
                    <input id="nombre" type="text" formControlName="nombre">
                </div>
                <div class="form-field-extended">
                    <label class="labelTitle" for="apellido1">{{ 'PREVIEW_SPACE.SURNAME1' | translate }}</label>
                    <input id="apellido1" type="text" formControlName="apellido1">
                </div>
                <div class="form-field-extended">
                    <label class="labelTitle" for="birthDate">{{ 'PREVIEW_SPACE.BIRTH_DATE' | translate }}</label>
                    <input id="birthDate" type="date" data-date-format="YYYY-MM-DD" formControlName="birthDate">
                </div>
                <div class="form-field-extended">
                    <label class="labelTitle" for="deathDate">{{ 'PREVIEW_SPACE.DEATH_DATE' | translate }}</label>
                    <input id="deathDate" type="date" data-date-format="YYYY-MM-DD" formControlName="deathDate">
                </div>
            </div>
            <div class="municipality-container">
                <div><label class="labelTitle" for="municipality">{{ 'PREVIEW_SPACE.DEATH_MUNICIPALITY_SELECT' |
                        translate }}</label></div>
                <div><app-cpm [comunidad]=true [provincia]=true [municipio]=true></app-cpm></div>
            </div>
        </div>

        <div class="reason-container">

            <div class="form-field full-width">
                <label class="checkbox-label">
                    <input type="checkbox" formControlName="selfDeclaration">{{'PREVIEW_SPACE.SELF_DECLARATION_MSG' | translate }}
                    </label>
            </div>

            <div class="form-field full-width" *ngIf="selfDeclarationSelected">
                <label class="labelTitle" for="motivoConsulta">{{ 'PREVIEW_SPACE.REQUEST_REASON' | translate }}</label>
                <textarea id="motivoConsulta" rows="4" formControlName="motivoConsulta"></textarea>
            </div>

        </div>

    </form>
</div>